module.exports = __webpack_public_path__ + "images/notifications/calendar-78e3b95ea6ab8300818c2700d09c2d1c.png";